/**
 * Client-verified dealership facts.
 *
 * Miami Car Queens is NOT a dealership. Gabriela and Chanira are automotive sales
 * professionals who work at the dealership below. Never describe Miami Car Queens
 * as a dealership, broker, or independent business selling vehicles.
 *
 * These values were provided and approved by the client. Everything still unknown
 * stays in config.ts as an empty constant.
 */
export const DEALERSHIP = {
  name: 'Doral Kia',
  address: '10155 NW 12th St, Doral, FL 33172',
  hours: {
    es: 'Lun–Vie 9:00AM–9:00PM · Sáb 9:00AM–8:00PM · Dom 11:00AM–7:00PM',
    en: 'Mon–Fri 9:00AM–9:00PM · Sat 9:00AM–8:00PM · Sun 11:00AM–7:00PM',
  },
} as const
